import * as Config from '../../../../config';
import { useContext, useEffect, useCallback } from "react";
import { ReactReduxContext, useSelector, useDispatch } from 'react-redux';

import useInvitPM from './useInvitPM';
import useNoSubscribeViewer from './useNoSubscribeViewer';

import {
  setMessagesPM
} from "../redux/actions/index";

let eventTrottle = null;
const usePartyMode = () => {
  const { store } = useContext(ReactReduxContext);
  const dispatch = useDispatch();
  useInvitPM();
  useNoSubscribeViewer();

  const connected = useSelector( state => state.socketConnectPM );
  const user = useSelector( state => state.user);
  const isSubscribed = useSelector( state => state.isSubscribed );
  const socket = useSelector( state => state.socketPM);
  const lockPM = useSelector( state => state.lockPM );
  const enable = useSelector( state => state.enablePM )
  const outsider = useSelector( state => state.isOutsider);

  const leaveRoom = useCallback((roomID) => () => {
    if (socket) {
      localStorage.removeItem('a5RAW%93W!gph8');
      socket.emit("leave room", { roomID });
      dispatch(setMessagesPM([]));
      removeMouseTracker();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socket]);

  useEffect(() => {
    const localSessionID = localStorage.getItem(`cQfdJ@gD8yjHqr`);
    const params = {
      userID: (user) ? user.id : localSessionID,
      username: (user) ? user.name : `Viewer-${localSessionID}`,
      avatar: (user) ? user.cover : Config.DEFAULT_AVATAR,
      from: Config.ACRONYME,
      outsider: outsider,
      subscribedlink: isSubscribed
    }
    if (socket && (user || outsider)) {
      if (socket.disconnected === true) {
        socket.auth = params;
        socket.connect();
        // console.log(`SOCKET CONNECTED`)
      } else if (socket.connected === true) {
        socket.emit("update socket", params);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, outsider, /*isSubscribed,*/ dispatch, socket, leaveRoom]);

  const createRoom = () => {
    dispatch(setMessagesPM([]));
    const statePlayer = null; // window.beatport_get_state()
    socket.emit("create room", { from: Config.ACRONYME, statePlayer });
  }
  const joinRoom = (roomID, admin = false, active = true, token = null) => () => {
    dispatch(setMessagesPM([]));
    socket.emit("join room", { roomID, admin, active, token });
  }

  const closeRoom = () => {
    localStorage.removeItem('a5RAW%93W!gph8');
    socket.emit("close room", {});
    dispatch(setMessagesPM([]));
    removeMouseTracker();
  }
  const joinDEV = () => {
    if (socket) {
      socket.emit("join dev room", { from: Config.ACRONYME });
    }
  }
  const throttle = (callback, delay) => {
    var previousCall = new Date().getTime();
    return function() {
      var time = new Date().getTime();
      if ((time - previousCall) >= delay) {
        previousCall = time;
        callback.apply(null, arguments);
      }
    };
  }
  const onMouseMove = (e) => {
    const p = document.getElementById(`player`).getBoundingClientRect(); // PLAYER COORDINATES WITH ZOOM INTEGRATED
    const x = ((e.clientX / window.window_zoom) - p.x);
    const y = ((e.clientY / window.window_zoom) - p.y);
    const scaleX = p.width / 1420;
    if (socket) {
      socket.emit("mouse move", { c: { x, y, w: p.width, h: p.height, s: scaleX } });
    }
  }
  const onMouseLeave = (e) => {
    if (socket) {
      socket.emit("mouse move", { c: { disable: true } });
    }
  }

  const isWatcher = useSelector( state => state.isWatcherPM );
  useEffect(() => {
    if (socket) {
      if (!isWatcher && !eventTrottle) {
        initMouseTracker()
      } else if (isWatcher && eventTrottle) {
        removeMouseTracker();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isWatcher, socket])

  const initMouseTracker = () => {
    eventTrottle = throttle(onMouseMove, 100); //old 10 - Optimize x10 with animation technique
    document.getElementById(`player`).addEventListener('mousemove', eventTrottle, true);
    document.getElementById(`alpha2`).addEventListener('mouseleave', onMouseLeave);
  }
  const removeMouseTracker = () => {
    if (eventTrottle) {
      document.getElementById(`player`).removeEventListener('mousemove', eventTrottle);
      document.getElementById(`alpha2`).removeEventListener('mouseleave', onMouseLeave);
    }
    eventTrottle = null;
  }

  const getRoomName = () => {
    const inRoomSession = store.getState().inRoomPM;
    return (inRoomSession) ? inRoomSession.name : null
  }

  const getRoomType = () => {
    const inRoomSession = store.getState().inRoomPM;
    return (inRoomSession) ? (inRoomSession.private ? 'Private' : 'Public') : `undefined`;
  }

  // Auto Selection after toggle PM
  useEffect(() => {
    if (socket && connected && enable && lockPM === false) {
      const roomID = localStorage.getItem('a5RAW%93W!gph8');
      const active = localStorage.getItem('5gxYD7Y&PqWmDW') ? (localStorage.getItem('5gxYD7Y&PqWmDW') === 'true') : false;
      const token = localStorage.getItem('UFg%PZHqK&5j4C');

      if (!roomID) { // DEPRECATED
        // createRoom();
      } else if (roomID) {
        joinRoom(roomID, false, active, token)(); // Notes: If user not exist on server, the active parameter will be used.
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[connected, socket, enable, lockPM])

  const storeX = {
    createRoom,
    leaveRoom,
    closeRoom,
    removeMouseTracker,
    getRoomName,
    getRoomType,
    joinDEV
  };

  return storeX;
};

export default usePartyMode;
